import { FC } from 'react';

import { Badge } from '@argenta/react-ui';

import { SchedulesEnum } from '../../enums';

import { locationI18nStrings, scheduleI18nStrings } from './VacancyBadges.strings';
import { VacancyBadgesProps } from './VacancyBadges.types';

import './VacancyBadges.styles.scss';

export const VacancyBadges: FC<VacancyBadgesProps> = ({ schedule, location }) => (
  <div className="argnt-c-vacancy-badges">
    {schedule !== SchedulesEnum.UNKNOWN && (
      <Badge value={scheduleI18nStrings()[schedule]} type="info" />
    )}
    <Badge value={locationI18nStrings()[location]} type="info" />
  </div>
);
